import { Lazyload } from "./vue-lazyload/index.mjs";
var stdin_default = Lazyload;
export {
  Lazyload,
  stdin_default as default
};
